/* Lumet product card scroll-reveal — targets .product-item */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init(){
    var cards = document.querySelectorAll('.product-item');
    if (!cards.length) return;
    cards.forEach(function(c){ c.classList.add('lumet-product-reveal'); });
    if (!('IntersectionObserver' in window)){
      cards.forEach(function(c){ c.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var parent = e.target.parentElement;
          var idx = parent ? Array.prototype.indexOf.call(parent.children, e.target) : 0;
          e.target.style.transitionDelay = Math.min(idx, 8) * 60 + 'ms';
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function(c){ io.observe(c); });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  if (window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load', function(){ setTimeout(init, 50); });
  }
})();
